export const consts = {
  AkamaiEdgescape: 'X-Akamai-Edgescape',
}
